module.exports = __webpack_public_path__ + "img/ios-download.8c1ab2bf.png";